// extracted by mini-css-extract-plugin
export default {"MFACodeInput":"MFACodeInput_MFACodeInput__pyI3Y","customCaret":"MFACodeInput_customCaret__0pD4D","description":"MFACodeInput_description__Uc+7i","error":"MFACodeInput_error__lT23C"};